<template>
  <!-- inline callout in normal flow: sits above the element the user must act on -->
  <div class="mb-4">
    <div class="bg-green-mint text-left rounded-lg p-4">
      <p class="m-0">
        {{ $t(copy) }}
      </p>
    </div>
    <!-- pointer cue aimed down at the target -->
    <svg
      class="block ml-8 text-green-mint fill-current"
      width="24"
      height="12"
      viewBox="0 0 24 12"
      aria-hidden="true"
    >
      <polygon points="0,0 24,0 12,12" />
    </svg>
  </div>
</template>
<script>

export default {
  props: {
    copy: {
      type: String,
      default: ''
    }
  }
}
</script>
